// extracted by mini-css-extract-plugin
module.exports = {"header":"FooterHeader_header__eAuYj","faqItemTitle":"FooterHeader_faqItemTitle__XKA8g","accordionButton":"FooterHeader_accordionButton__VaH80"};